import * as React from 'react';
import { useContext } from 'react';

export type DegreeDescriptionPageElementRefsContextType = {
  floatingEoiButtonsContainerRef?: HTMLElement | null;
  setFloatingEoiButtonsContainerRef?: (elm: HTMLElement) => void;
  heroBannerRef?: HTMLElement | null;
  setHeroBannerRef?: (elm: HTMLElement) => void;
  navbarRef?: HTMLElement | null;
  setNavbarRef?: (elm: HTMLElement) => void;
  eoiFormAnchorRef?: HTMLElement | null;
  setEoiFormAnchorRef?: (elm: HTMLElement) => void;
};

export const DegreeDescriptionPageElementRefsContext = React.createContext<
  DegreeDescriptionPageElementRefsContextType | undefined
>(undefined);

export const useDegreeDescriptionPageElementRefs = () => {
  const context = useContext(DegreeDescriptionPageElementRefsContext);
  if (!context)
    throw new Error('useDegreeDescriptionPageElementRefs was used outside of DegreeDescriptionPageElementRefsContext');
  return context;
};

export default DegreeDescriptionPageElementRefsContext;
